/* global $, prestashop */

$(document).ready(() => {
  const form = $('#add-to-cart-or-refresh');
  const modal = $('#mass-add-to-cart-modal');
  const modalBody = modal.find('.modal-body');

  $(document).on('change', '.js-measurement-unit-select', (e) => {
    const quantityInput = $('#quantity_wanted');
    const selectedOption = $(e.currentTarget).find('option:selected');
    const multiplier = parseInt(selectedOption.data('multiplier'));

    let min = parseInt(quantityInput.data('min'));

    if (multiplier > 1) {
      min = Math.ceil(min / multiplier);
    }

    quantityInput.attr('min', min);
    quantityInput.val(min);

    prestashop.emit('updateProduct', {
      eventType: 'updatedProductQuantity',
      event: e,
    });
  });

  form.on('change', '.js-mass-add-qty-input', (e) => {
    e.stopPropagation();

    const input = $(e.currentTarget);
    const value = parseInt(input.val());
    const minValue = parseInt(input.attr('data-min'));

    if (value < minValue) {
      const previousValue = parseInt(input.attr('data-previous-value'));

      let newValue = previousValue < value ? minValue : 0;

      input.val(newValue);
      input.attr('data-previous-value', newValue);
    } else {
      input.attr('data-previous-value', value);
    }
  });

  form.on('touchspin.on.startspin', '.js-mass-add-qty-input', (e) => {
    e.stopPropagation();
  });

  form.on('change', '.js-mass-add-measurement-unit-select', (e) => {
    e.stopPropagation();

    const select = $(e.currentTarget);
    const selectedOption = select.find('option:selected');
    const quantityInput = select.closest('.row').find('.js-mass-add-qty-input');
    const multiplier = parseInt(selectedOption.data('multiplier'));

    let min = parseInt(quantityInput.data('min-quantity'));
    let max = parseInt(quantityInput.data('max'));

    if (multiplier > 1) {
      min = Math.ceil(min / multiplier);
      if (!isNaN(max)) {
        max = Math.floor(max / multiplier);;
      }
    }

    quantityInput.val(0);
    quantityInput.attr('data-previous-value', 0);
    quantityInput.attr('data-min', min);

    if (!isNaN(max)) {
      quantityInput.attr('max', max);
      quantityInput.trigger('touchspin.updatesettings', {max: max});
    }
  });

  $(document).on('click', '.js-mass-add-submit', (e) => {
    e.preventDefault();

    const button = $(e.currentTarget);

    $.ajax({
      url: button.data('action'),
      method: 'post',
      data: form.serialize(),
      success: function (response) {
        if (response.success) {
          prestashop.emit('updateCart', {
            reason: {
              cart: response.cart,
            },
          });

          modalBody.html(response.modal);
          modal.modal('show');

          $('.js-mass-add-qty-input')
            .val(0)
            .attr('data-previous-value', 0);
        } else if ('error' in response) {
          alert(response.error);
        } else {
          console.log(JSON.stringify(response));
        }
      }
    });
  });
});
